import reportPresetReducer from "./reducers";

export default reportPresetReducer;